import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { IntegrationApiService } from './integration-api.service';

@Injectable()
export class WhiteLabelResolver  {
  constructor(private integrationApiService: IntegrationApiService) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    return route.queryParams['company-branding']
      ? this.integrationApiService.getCompanyBranding(route.queryParams['company-branding'])
      : null;
  }
}
